// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"132":"reception","245":"notfound","571":"settings","805":"transactions","992":"reports"}[chunkId] || chunkId) + "." + {"132":"b2eaf318","245":"755c683b","571":"50aadb38","601":"e7278706","805":"2a8b9b2f","832":"045a6c4b","992":"725d6959"}[chunkId] + ".js";
};